import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import { injectIntl } from 'react-intl'
import * as Yup from 'yup'
import { UploadDocumentModal } from './UploadDocumentModal'
import { userProfileUpdateAsync } from '../../../Auth/_redux'
import ethereum_address from 'ethereum-address'

const AccountVerificationTab = ({
  user,
  isLoading,
  intl,
  UploadDocumentAsync,
  uploadModal,
  AuthActions,
}) => {
  const [selectedDoc, setSelectedDoc] = useState({})
  const [walletAddress, setWalletAddress] = useState(user.walletAddress || '')
  const [walletAddressValidity, setWalletAddressValidity] = useState(true)

  const uploadClose = () => {
    dispatch(AuthActions.toggleUploadDocumentModal(false))
    setSelectedDoc({})
  }
  const uploadShow = () => dispatch(AuthActions.toggleUploadDocumentModal(true))

  const dispatch = useDispatch()

  const initialValues = {
    bankAccountNumber: user.bankAccountNumber || '',
    swiftCode: user.swiftCode || '',
    walletAddress: user.walletAddress || '',
  }

  const AccountVerificationSchema = Yup.object().shape({
    // bankAccountNumber: Yup.string()
    //     .required(
    //         intl.formatMessage({
    //             id: "AUTH.VALIDATION.REQUIRED_FIELD",
    //         })
    //     ),
    // swiftCode: Yup.string()
    //     .required(
    //         intl.formatMessage({
    //             id: "AUTH.VALIDATION.REQUIRED_FIELD",
    //         })
    //     ),
    walletAddress: Yup.string().required(
      intl.formatMessage({
        id: 'AUTH.VALIDATION.REQUIRED_FIELD',
      }),
    ),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: AccountVerificationSchema,
    onSubmit: (values) => {
      console.log(values)
    },
  })

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }

    return ''
  }

  const onDocSubmit = (data) => {
    console.log(data)
    let docs,
      finalData = {}
    console.log(selectedDoc)
    if (selectedDoc._id) {
      docs = user.document.filter((doc) => doc._id !== selectedDoc._id)
    } else {
      docs = user.document
    }
    let formData = null
    if (data.file) {
      formData = new FormData()
      formData.append('img', data.file)
    }
    finalData = {
      URL: data.url,
      type: data.type,
      createdAt: new Date(),
    }
    if (selectedDoc) {
      finalData = {
        ...finalData,
        _id: selectedDoc._id,
      }
    }
    dispatch(UploadDocumentAsync(user._id, finalData, formData, docs))
  }

  const onEditButtonClick = (doc) => {
    setSelectedDoc(doc)
    uploadShow()
  }

  const onRemoveDocClick = (removeDoc) => {
    if (removeDoc.verified !== 'VERIFIED') {
      let docs = user.document.filter((doc) => doc._id !== removeDoc._id)
      dispatch(UploadDocumentAsync(user._id, null, null, docs))
    }
  }

  const onupdate = () => {
    formik.values.walletAddress = walletAddress
    console.log(formik.values)

    dispatch(userProfileUpdateAsync(formik.values, user._id))
  }

  const handleWalletAddress = (e) => {
    const walletAddress = e.target.value
    try {
      if (ethereum_address.isChecksumAddress(walletAddress)) {
        setWalletAddressValidity(true)
      } else {
        setWalletAddressValidity(false)
      }
    } catch (e) {
      setWalletAddressValidity(false)
    }

    setWalletAddress(walletAddress)
  }

  return (
    <>
      <div className="tblmrgn mt-0 lwpddng cstm_pddng">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <form
              className="form def_form frmwtpddng pd_1199_15"
              onSubmit={formik.handleSubmit}
            >
              <div className="row">
                {/* <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">Bank Account Number</label>
                                        <input
                                            placeholder="000000000000"
                                            type="text"
                                            className={`form-control ${getInputClasses(
                                                "bankAccountNumber"
                                            )} password-valid`}
                                            name="bankAccountNumber"
                                            {...formik.getFieldProps("bankAccountNumber")}
                                        />
                                        {formik.touched.bankAccountNumber && formik.errors.bankAccountNumber ? (
                                            <div className="fv-plugins-message-container">
                                                <div className="fv-help-block">{formik.errors.bankAccountNumber}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div> */}
                {/* <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">Swift Code</label>
                                        <input
                                            placeholder="000000000000"
                                            type="text"
                                            className={`form-control ${getInputClasses(
                                                "swiftCode"
                                            )} password-valid`}
                                            name="swiftCode"
                                            {...formik.getFieldProps("swiftCode")}
                                        />
                                        {formik.touched.swiftCode && formik.errors.swiftCode ? (
                                            <div className="fv-plugins-message-container">
                                                <div className="fv-help-block">{formik.errors.swiftCode}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div> */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="form-label pr-2">Wallet Address</label>
                    {walletAddressValidity ? (
                      <i className="fas fa-check-circle green"></i>
                    ) : (
                      <i className="fas fa-times-circle"></i>
                    )}
                    <input
                      placeholder="Enter an Ethereum wallet address"
                      type="text"
                      className={`form-control ${getInputClasses(
                        'walletAddress',
                      )} password-valid`}
                      name="walletAddress"
                      {...formik.getFieldProps('walletAddress')}
                      onChange={handleWalletAddress}
                      value={walletAddress}
                    />
                    {user.verified === 'VERIFIED' ? (
                      <span className="vrfd_txt">
                        <span className="material-icons">verified_user</span>
                        Verified
                      </span>
                    ) : null}
                    {(formik.touched.walletAddress &&
                      walletAddressValidity == false) ||
                    (formik.touched.walletAddress &&
                      formik.errors.walletAddress) ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.walletAddress}
                        </div>
                      </div>
                    ) : null}
                    <div className="form-text text-muted">
                      NOTE: The Ethereum wallet address used here must be unique
                      and must not be used by any other user.
                    </div>
                    <div className="text-muted form-text mt-2">
                      Don't have an Ethereum wallet?{' '}
                      <a href="https://metamask.io" target="_blank">
                        Click here
                      </a>{' '}
                      to set one up.
                    </div>
                  </div>
                </div>
                <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-4">
                  <button
                    disabled={isLoading}
                    type="button"
                    className="btn btn-def btn-defv4"
                    onClick={onupdate}
                  >
                    <span>Update</span>
                    {isLoading && (
                      <span className="ml-3 spinner spinner-white"></span>
                    )}
                  </button>
                </div>
                <div className="col-md-12 d-flex align-items-center mt-15">
                  <h4 className="fn_s_18 f-w-500 color_blk mb-0">Document</h4>
                  <button
                    type="button"
                    className="btn btn-def btn-defv6 ml-5"
                    onClick={uploadShow}
                  >
                    Upload
                  </button>
                </div>
                <div className="col-md-12 mt-5">
                  {user && user.document && user.document.length
                    ? user.document.map((doc) => (
                        <div className="madia_box" key={doc._id}>
                          <img alt="" className="img-fluid" src={doc.URL} />
                          <div className="d-flex align-items-center">
                            <h6 className="fn_s_16 f-w-400 color_blk mb-0 elptcl_h6">
                              {doc.type}
                            </h6>
                            {doc.verified === 'VERIFIED' && (
                              <span className="d-flex vrfd_txt vrfd_txt_v2">
                                <span className="material-icons">
                                  verified_user
                                </span>
                                {doc.verified}
                              </span>
                            )}
                            {doc.verified === 'REJECTED' && (
                              <>
                                <span className="d-flex rjct_txt vrfd_txt_v2">
                                  <span className="material-icons">
                                    report_problem
                                  </span>
                                  {doc.verified}
                                </span>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() => onEditButtonClick(doc)}
                                >
                                  <span className="material-icons">create</span>
                                </button>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() => onRemoveDocClick(doc)}
                                >
                                  <span className="material-icons">close</span>
                                </button>
                              </>
                            )}
                            {doc.verified === 'PENDING' && (
                              <div className="id_actions">
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() => onEditButtonClick(doc)}
                                >
                                  <span className="material-icons">create</span>
                                </button>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() => onRemoveDocClick(doc)}
                                >
                                  <span className="material-icons">close</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <UploadDocumentModal
        uploadModal={uploadModal}
        uploadClose={uploadClose}
        isLoading={isLoading}
        onDocSubmit={onDocSubmit}
        selectedDoc={selectedDoc}
      />
    </>
  )
}

export default injectIntl(AccountVerificationTab)
